import React from 'react';
import useSync from '../hooks/useSync';
import './SyncIndicator.css';

function SyncIndicator() {
  const { syncStatus: status, lastSynced, configured } = useSync();

  if (!configured) return null;

  const statusConfig = {
    idle: { icon: '●', className: 'sync-indicator--idle', title: 'Synced' },
    syncing: { icon: '↻', className: 'sync-indicator--syncing', title: 'Syncing...' },
    offline: { icon: '○', className: 'sync-indicator--offline', title: 'Offline' },
    error: { icon: '!', className: 'sync-indicator--error', title: 'Sync error' },
  };

  const cfg = statusConfig[status] || statusConfig.idle;

  const timeAgo = lastSynced
    ? `Last synced: ${lastSynced.toLocaleTimeString()}`
    : 'Not yet synced';

  return (
    <div
      className={`sync-indicator ${cfg.className}`}
      title={`${cfg.title} — ${timeAgo}`}
      aria-label={`${cfg.title}. ${timeAgo}`}
      role="status"
    >
      <span className="sync-indicator__icon">{cfg.icon}</span>
    </div>
  );
}

export default SyncIndicator;
